import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

type OfferDialogV2 = {
    offerDialogV2: boolean
}

const useOfferDialogV2Store = create<OfferDialogV2>()(
    persist(
        devtools(
            (set) => ({
                offerDialogV2: false,
            }),
            {
                name: 'OfferDialogV2Store',
            },
        ),
        { name: 'offer-dialog-v2' },
    ),
)

export const useOfferDialogV2 = () => useOfferDialogV2Store((state) => state.offerDialogV2)
export const getOfferDialogV2State = () => useOfferDialogV2Store.getState().offerDialogV2
export const setOfferDialogV2 = (state: boolean) => useOfferDialogV2Store.setState({ offerDialogV2: state })
export const toggleOfferDialogV2 = () => setOfferDialogV2(!getOfferDialogV2State())
